module.exports = __webpack_public_path__ + "img/icon-soloway.b89bd4a6.svg";